import Contract from './GeneralContract'

class LifeInsuranceAxaContract extends Contract {
  constructor(props) {
    super(props)
    this.details = this.details || {
      fallcc: 0,
      falla: 0,
      fallac: 0,
      ipacc: 0,
      ipaa: 0,
      ipaac: 0,
      ginv: 0
    }
  }

  updateDetails(details) {
    const monthlyPrice = details.price / 12

    // add months
    const items = []
    if (details.startDate != null) {
      for (let month = details.startDate; month < 12; month += 1) {
        this.benefit.monthsAvailability[month] &&
          items.push({
            familyId: 0,
            month,
            price: monthlyPrice,
          })
      }
    }
    this.details = details
    this.items = items

    this.updatePrice()
  }
}

export default LifeInsuranceAxaContract
